import {Vue, Watch} from "vue-property-decorator";
import bus from "@/main";
import BaseComponent from "@/core/components/BaseComponent";
import _ from "lodash";

export class BaseList extends BaseComponent {
    totalItems: number = 0;
    loading: boolean = false;
    options = {};
    search = "";
    protected modelName = ""; // Override
    private debouncedSearch?: any;

    public created() {
        bus.$on(`${this.modelName}Saved`, () => {
            this.getItems(true, true);
        });
        this.debouncedSearch = _.debounce(this.onTableSearchChange, 300);
    }

    public mounted() {
        this.getItems(false, true);
    }

    public createItem() {
        bus.$emit(`${this.modelName}Edit`, 0);
    }

    public editItem(item: {id?: number}) {
        bus.$emit(`${this.modelName}Edit`, item.id);
    }

    @Watch("options")
    protected onTableInputChange() {
        this.getItems(true, false);
    }

    @Watch("search")
    private onSearchChange() {
        this.debouncedSearch();
    }

    public onTableSearchChange() {
        this.getItems(true, true);
    }

    protected getItems(doItems = true, doCount = false) {
        // Override
    }

    public footerProps = {
        itemsPerPageOptions: [10,25,50,100,-1],
        itemsPerPageAllText: 'Alle',
        itemsPerPageText: 'Rækker pr. side',
    }
}
